const $ = jQuery.noConflict();

'use strict';
const ProductFinderToggle = {
	/**
	 * @description Cache DOM and strings
	 * @type {object}
	 */
	$domOpenButton: $('.js-product-finder-open'),
	$domCloseButton: $('.js-product-finder-close'),
	$domProductFinder: $('.js-product-finder'),
	$domProductFinderForm: $('.js-product-finder-form'),
	classActive: 'is-active',

	/** @description Initialize */
	init: function() {
		this.bindEvents();
	},

	/** @description Bind Events */
	bindEvents: function() {
		// Open the product finder
		this.$domOpenButton.on('click', this.openFinder.bind(this));

		// Close the product finder
		this.$domCloseButton.on('click', this.closeFinder.bind(this));

		// Close when clicking outside the finder
		$(document).on('click', this.handleOutsideClick.bind(this));
	},

	/** @description Open the Product Finder */
	openFinder: function() {
		this.$domProductFinder.addClass(this.classActive);
	},

	/** @description Close the Product Finder */
	closeFinder: function() {
		this.$domProductFinder.removeClass(this.classActive);
	},

	/** @description Handle Click Outside the Product Finder */
	handleOutsideClick: function(e) {
		const isOutside = !$(e.target).closest(this.$domProductFinderForm).length && !$(e.target).closest(this.$domOpenButton).length;

		if (isOutside) {
			this.closeFinder();
		}
	}
};

export default ProductFinderToggle;
